<template>
  <div class="content">
    <el-carousel height="400px">
      <el-carousel-item v-for="item in 1" :key="item">
        <img alt="loading" src="../assets/1.png" class="wth100" />
      </el-carousel-item>
    </el-carousel>
    <h1 class="comp_title">一诚天和</h1>
    <!-- 顶部菜单 -->
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="1">一诚天和•首页</el-menu-item>
      <el-menu-item index="2">关于我们</el-menu-item>
      <el-menu-item index="3">服务中心</el-menu-item>
      <el-menu-item index="4" disabled>新闻资讯</el-menu-item>
      <el-menu-item index="4" disabled>企业荣誉</el-menu-item>
    </el-menu>
    <!-- 轮播图 -->
    <div v-if="activeIndex === '1'">
      <img src="@/assets/des.png" class="cursor" />
      <img src="@/assets/des0.png" class="cursor" />
    </div>
    <div v-if="activeIndex === '2'">
      <img src="@/assets/des2.png" class="cursor" />
      <img src="@/assets/des3.png" class="cursor" />
    </div>
    <div v-if="activeIndex === '3'">
      <img src="@/assets/des4.png" class="cursor" />
      <img src="@/assets/des5.png" class="cursor" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const activeIndex = ref("1");
const handleSelect = (val) => {
  activeIndex.value = val;
};
</script>

<style scoped>
.wth100 {
  width: 100%;
}
.content {
  position: relative;
  width: 1400px;
  margin: 0 auto;
  background-color: #ffffff;  
}
.comp_title{
  position: absolute;
  top: 5%;
  left: 20%;
  font-size: 70px;
}
.el-menu-item {
  width: 260px;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
